export const Geolocation = {
  countries: [
    { country_id: 1, name: "India" },
    { country_id: 2, name: "United States of America" },
  ].sort((a, b) => a.name.localeCompare(b.name)),
  states: [
    { country_id: 1, state_id: 1, name: "Andaman & Nicobar" },
    { country_id: 1, state_id: 2, name: "Andhra Pradesh" },
    { country_id: 1, state_id: 3, name: "Arunachal Pradesh" },
    { country_id: 1, state_id: 4, name: "Assam" },
    { country_id: 1, state_id: 5, name: "Bihar" },
    { country_id: 1, state_id: 6, name: "Chandigarh" },
    { country_id: 1, state_id: 7, name: "Chhattisgarh" },
    { country_id: 1, state_id: 8, name: "Dadra and Nagar Haveli" },
    { country_id: 1, state_id: 9, name: "Daman & Diu" },
    { country_id: 1, state_id: 10, name: "Delhi" },
    { country_id: 1, state_id: 11, name: "Goa" },
    { country_id: 1, state_id: 12, name: "Gujarat" },
    { country_id: 1, state_id: 13, name: "Haryana" },
    { country_id: 1, state_id: 14, name: "Himachal Pradesh" },
    { country_id: 1, state_id: 15, name: "Jammu & Kashmir" },
    { country_id: 1, state_id: 16, name: "Jharkhand" },
    { country_id: 1, state_id: 17, name: "Karnataka" },
    { country_id: 1, state_id: 18, name: "Kerala" },
    { country_id: 1, state_id: 19, name: "Ladkah" },
    { country_id: 1, state_id: 20, name: "Madhya Pradesh" },
    { country_id: 1, state_id: 21, name: "Maharashtra" },
    { country_id: 1, state_id: 22, name: "Manipur" },
    { country_id: 1, state_id: 23, name: "Meghalaya" },
    { country_id: 1, state_id: 24, name: "Mizoram" },
    { country_id: 1, state_id: 25, name: "Nagaland" },
    { country_id: 1, state_id: 26, name: "Odisha" },
    { country_id: 1, state_id: 27, name: "Puducherry" },
    { country_id: 1, state_id: 28, name: "Punjab" },
    { country_id: 1, state_id: 29, name: "Rajasthan" },
    { country_id: 1, state_id: 30, name: "Sikkim" },
    { country_id: 1, state_id: 31, name: "Tamil Nadu" },
    { country_id: 1, state_id: 32, name: "Telangana" },
    { country_id: 1, state_id: 33, name: "Tripura" },
    { country_id: 1, state_id: 34, name: "Uttar Pradesh" },
    { country_id: 1, state_id: 35, name: "Uttarakhand" },
    { country_id: 1, state_id: 36, name: "West Bengal" },

    { country_id: 2, state_id: 1, name: "Alabama" },
    { country_id: 2, state_id: 2, name: "Alaska" },
    { country_id: 2, state_id: 3, name: "Arizona" },
    { country_id: 2, state_id: 4, name: "Arkansas" },
    { country_id: 2, state_id: 5, name: "California" },
    { country_id: 2, state_id: 6, name: "Colorado" },
    { country_id: 2, state_id: 7, name: "Connecticut" },
    { country_id: 2, state_id: 8, name: "Delaware" },
    { country_id: 2, state_id: 9, name: "Florida" },
    { country_id: 2, state_id: 10, name: "Georgia" },
    { country_id: 2, state_id: 11, name: "Hawaii" },
    { country_id: 2, state_id: 12, name: "Idaho" },
    { country_id: 2, state_id: 13, name: "Illinois" },
    { country_id: 2, state_id: 14, name: "Indiana" },
    { country_id: 2, state_id: 15, name: "Iowa" },
    { country_id: 2, state_id: 16, name: "Kansas" },
    { country_id: 2, state_id: 17, name: "Kentucky" },
    { country_id: 2, state_id: 18, name: "Louisiana" },
    { country_id: 2, state_id: 19, name: "Maine" },
    { country_id: 2, state_id: 20, name: "Maryland" },
    { country_id: 2, state_id: 21, name: "Massachusetts" },
    { country_id: 2, state_id: 22, name: "Michigan" },
    { country_id: 2, state_id: 23, name: "Minnesota" },
    { country_id: 2, state_id: 24, name: "Mississippi" },
    { country_id: 2, state_id: 25, name: "Missouri" },
    { country_id: 2, state_id: 26, name: "Montana" },
    { country_id: 2, state_id: 27, name: "Nebraska" },
    { country_id: 2, state_id: 28, name: "Nevada" },
    { country_id: 2, state_id: 29, name: "New Hampshire" },
    { country_id: 2, state_id: 30, name: "New Jersey" },
    { country_id: 2, state_id: 31, name: "New Mexico" },
    { country_id: 2, state_id: 32, name: "New York" },
    { country_id: 2, state_id: 33, name: "North Carolina" },
    { country_id: 2, state_id: 34, name: "North Dakota" },
    { country_id: 2, state_id: 35, name: "Ohio" },
    { country_id: 2, state_id: 36, name: "Oklahoma" },
    { country_id: 2, state_id: 37, name: "Oregon" },
    { country_id: 2, state_id: 38, name: "Pennsylvania" },
    { country_id: 2, state_id: 39, name: "Rhode Island" },
    { country_id: 2, state_id: 40, name: "South Carolina" },
    { country_id: 2, state_id: 41, name: "South Dakota" },
    { country_id: 2, state_id: 42, name: "Tennessee" },
    { country_id: 2, state_id: 43, name: "Texas" },
    { country_id: 2, state_id: 44, name: "Utah" },
    { country_id: 2, state_id: 45, name: "Vermont" },
    { country_id: 2, state_id: 46, name: "Virginia" },
    { country_id: 2, state_id: 47, name: "Washington" },
    { country_id: 2, state_id: 48, name: "West Virginia" },
    { country_id: 2, state_id: 49, name: "Wisconsin" },
    { country_id: 2, state_id: 50, name: "Wyoming" },
  ].sort((a, b) => a.name.localeCompare(b.name)),
  cities: [
    { country_id: 1, state_id: 1, city_id: 1, name: "South Andaman" },
    { country_id: 1, state_id: 2, city_id: 2, name: "Anantapuramu" },
    { country_id: 1, state_id: 2, city_id: 3, name: "Chittoor" },
    { country_id: 1, state_id: 2, city_id: 4, name: "East Godavari" },
    { country_id: 1, state_id: 2, city_id: 5, name: "Gachibowli" },
    { country_id: 1, state_id: 2, city_id: 6, name: "Guntur" },
    { country_id: 1, state_id: 2, city_id: 7, name: "Hyderabad" },
    { country_id: 1, state_id: 2, city_id: 8, name: "Krishna" },
    { country_id: 1, state_id: 2, city_id: 9, name: "Kurnool" },
    { country_id: 1, state_id: 2, city_id: 10, name: "Mahbubnagar" },
    { country_id: 1, state_id: 2, city_id: 11, name: "Medchal–Malkajgiri" },
    { country_id: 1, state_id: 2, city_id: 12, name: "Prakasam" },
    { country_id: 1, state_id: 2, city_id: 13, name: "Ranga Reddy" },
    { country_id: 1, state_id: 2, city_id: 15, name: "Sangareddy" },
    {
      country_id: 1,
      state_id: 2,
      city_id: 16,
      name: "Sri Potti Sriramulu Nellore",
    },
    { country_id: 1, state_id: 2, city_id: 17, name: "Srikakulam" },
    { country_id: 1, state_id: 2, city_id: 18, name: "Tadepalligudem" },
    { country_id: 1, state_id: 2, city_id: 19, name: "Visakhapatnam" },
    { country_id: 1, state_id: 2, city_id: 20, name: "West Godavari" },
    { country_id: 1, state_id: 2, city_id: 21, name: "YSR Kadapa" },
    { country_id: 1, state_id: 3, city_id: 23, name: "Papum pare" },
    { country_id: 1, state_id: 3, city_id: 24, name: "Itanagar" },
    { country_id: 1, state_id: 4, city_id: 25, name: "Cachar" },
    { country_id: 1, state_id: 4, city_id: 26, name: "Dibrugarh" },
    { country_id: 1, state_id: 4, city_id: 27, name: "Jorhat" },
    { country_id: 1, state_id: 4, city_id: 28, name: "Kamrup Metropolitan" },
    { country_id: 1, state_id: 4, city_id: 29, name: "Sonitpur" },
    { country_id: 1, state_id: 5, city_id: 30, name: "Begusarai" },
    { country_id: 1, state_id: 5, city_id: 31, name: "Bhagalpur" },
    { country_id: 1, state_id: 5, city_id: 32, name: "Chandigarh" },
    { country_id: 1, state_id: 5, city_id: 33, name: "East Champaran" },
    { country_id: 1, state_id: 5, city_id: 34, name: "Gaya" },
    { country_id: 1, state_id: 5, city_id: 35, name: "Katihar" },
    { country_id: 1, state_id: 5, city_id: 36, name: "Muzaffarnagar" },
    { country_id: 1, state_id: 5, city_id: 37, name: "Nalanda" },
    { country_id: 1, state_id: 5, city_id: 38, name: "Patna" },
    { country_id: 1, state_id: 5, city_id: 39, name: "Purnea" },
    { country_id: 1, state_id: 5, city_id: 40, name: "Rohtas" },
    { country_id: 1, state_id: 5, city_id: 41, name: "Samastipur" },
    { country_id: 1, state_id: 5, city_id: 42, name: "Vaishali" },
    { country_id: 1, state_id: 6, city_id: 43, name: "Chandigarh" },
    { country_id: 1, state_id: 6, city_id: 44, name: "Mohali" },
    { country_id: 1, state_id: 6, city_id: 45, name: "Panchkula" },
    { country_id: 1, state_id: 6, city_id: 46, name: "Zirakpur" },
    { country_id: 1, state_id: 7, city_id: 47, name: "Bilaspur" },
    { country_id: 1, state_id: 7, city_id: 48, name: "Durg" },
    { country_id: 1, state_id: 7, city_id: 49, name: "Korba" },
    { country_id: 1, state_id: 7, city_id: 50, name: "Raigarh" },
    { country_id: 1, state_id: 7, city_id: 51, name: "Raipur" },
    { country_id: 1, state_id: 7, city_id: 52, name: "Rajnandgaon" },
    { country_id: 1, state_id: 8, city_id: 53, name: "Silvassa" },
    { country_id: 1, state_id: 9, city_id: 54, name: "Diu" },
    { country_id: 1, state_id: 10, city_id: 55, name: "Delhi" },
    { country_id: 1, state_id: 11, city_id: 56, name: "North Goa" },
    { country_id: 1, state_id: 11, city_id: 57, name: "Panaji" },
    { country_id: 1, state_id: 11, city_id: 58, name: "South Goa" },
    { country_id: 1, state_id: 12, city_id: 59, name: "Adalaj" },
    { country_id: 1, state_id: 12, city_id: 60, name: "Ahmedabad" },
    { country_id: 1, state_id: 12, city_id: 61, name: "Ankleshwar" },
    { country_id: 1, state_id: 12, city_id: 62, name: "Anand" },
    { country_id: 1, state_id: 12, city_id: 63, name: "Aravalli" },
    { country_id: 1, state_id: 12, city_id: 64, name: "Banaskantha" },
    { country_id: 1, state_id: 12, city_id: 65, name: "Bharuch" },
    { country_id: 1, state_id: 12, city_id: 66, name: "Bhavnagar" },
    { country_id: 1, state_id: 12, city_id: 67, name: "Bhilad" },
    { country_id: 1, state_id: 12, city_id: 68, name: "Chhatral" },
    { country_id: 1, state_id: 12, city_id: 69, name: "Devbhoomi Dwarka" },
    { country_id: 1, state_id: 12, city_id: 70, name: "Gandhinagar" },
    { country_id: 1, state_id: 12, city_id: 71, name: "Jamnagar" },
    { country_id: 1, state_id: 12, city_id: 72, name: "Junagadh" },
    { country_id: 1, state_id: 12, city_id: 73, name: "Kheda" },
    { country_id: 1, state_id: 12, city_id: 74, name: "Kutch" },
    { country_id: 1, state_id: 12, city_id: 75, name: "Mehsana" },
    { country_id: 1, state_id: 12, city_id: 76, name: "Morbi" },
    { country_id: 1, state_id: 12, city_id: 77, name: "Navsari" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Panchmahal" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Patan" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Porbandar" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Rajkot" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Sabarkantha" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Surat" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Surendranagar" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Vadodara/Baroda" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Valsad" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Vijapur" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Vitthal Udhyognagar" },
    { country_id: 1, state_id: 13, city_id: 79, name: "Ambala" },
    { country_id: 1, state_id: 13, city_id: 80, name: "Bahadurgarh" },
    { country_id: 1, state_id: 13, city_id: 81, name: "Bhiwani" },
    { country_id: 1, state_id: 13, city_id: 82, name: "Chandigarh" },
    { country_id: 1, state_id: 13, city_id: 83, name: "Faridabad" },
    { country_id: 1, state_id: 13, city_id: 84, name: "Gurgaon" },
    { country_id: 1, state_id: 13, city_id: 85, name: "Gurugram" },
    { country_id: 1, state_id: 13, city_id: 86, name: "Hisar" },
    { country_id: 1, state_id: 13, city_id: 87, name: "Jhajjar" },
    { country_id: 1, state_id: 13, city_id: 88, name: "Jind" },
    { country_id: 1, state_id: 13, city_id: 89, name: "Kaithal" },
    { country_id: 1, state_id: 13, city_id: 90, name: "Karnal" },
    { country_id: 1, state_id: 13, city_id: 91, name: "Kurukshetra" },
    { country_id: 1, state_id: 13, city_id: 92, name: "Mahendragarh" },
    { country_id: 1, state_id: 13, city_id: 93, name: "Manesar" },
    { country_id: 1, state_id: 13, city_id: 94, name: "Mewat" },
    { country_id: 1, state_id: 13, city_id: 95, name: "Palwal" },
    { country_id: 1, state_id: 13, city_id: 96, name: "Panchkula" },
    { country_id: 1, state_id: 13, city_id: 97, name: "Panipat" },
    { country_id: 1, state_id: 13, city_id: 98, name: "Rewari" },
    { country_id: 1, state_id: 13, city_id: 99, name: "Rohtak" },
    { country_id: 1, state_id: 13, city_id: 100, name: "Sirsa" },
    { country_id: 1, state_id: 13, city_id: 101, name: "Sonipat" },
    { country_id: 1, state_id: 13, city_id: 102, name: "Yamunanagar" },
    { country_id: 1, state_id: 14, city_id: 103, name: "Hamirpur" },
    { country_id: 1, state_id: 14, city_id: 104, name: "Kangra" },
    { country_id: 1, state_id: 14, city_id: 105, name: "Kullu" },
    { country_id: 1, state_id: 14, city_id: 106, name: "Manali" },
    { country_id: 1, state_id: 14, city_id: 107, name: "Mandi" },
    { country_id: 1, state_id: 14, city_id: 108, name: "Shimla" },
    { country_id: 1, state_id: 14, city_id: 109, name: "Sirmaur" },
    { country_id: 1, state_id: 14, city_id: 110, name: "Solan" },
    { country_id: 1, state_id: 14, city_id: 111, name: "Una" },
    { country_id: 1, state_id: 14, city_id: 112, name: "Lahaul And Spiti" },
    { country_id: 1, state_id: 15, city_id: 113, name: "Jammu" },
    { country_id: 1, state_id: 15, city_id: 114, name: "Srinagar" },
    { country_id: 1, state_id: 16, city_id: 115, name: "Bokaro" },
    { country_id: 1, state_id: 16, city_id: 116, name: "Deoghar" },
    { country_id: 1, state_id: 16, city_id: 117, name: "Dhanbad" },
    { country_id: 1, state_id: 16, city_id: 118, name: "East Singhbhum" },
    { country_id: 1, state_id: 16, city_id: 119, name: "Giridih" },
    { country_id: 1, state_id: 16, city_id: 120, name: "Jamshedpur" },
    { country_id: 1, state_id: 16, city_id: 121, name: "Ranchi" },
    { country_id: 1, state_id: 16, city_id: 122, name: "Seraikela Kharsawan" },
    { country_id: 1, state_id: 16, city_id: 123, name: "Singhbhum" },
    { country_id: 1, state_id: 16, city_id: 124, name: "Palamu" },
    { country_id: 1, state_id: 17, city_id: 125, name: "Bagalkot" },
    { country_id: 1, state_id: 17, city_id: 126, name: "Bengaluru" },
    { country_id: 1, state_id: 17, city_id: 127, name: "Bidar" },
    { country_id: 1, state_id: 17, city_id: 128, name: "Bijapur" },
    { country_id: 1, state_id: 17, city_id: 129, name: "Chikkaballapur" },
    { country_id: 1, state_id: 17, city_id: 130, name: "Chikkamagaluru" },
    { country_id: 1, state_id: 17, city_id: 131, name: "Dakshina Kannada" },
    { country_id: 1, state_id: 17, city_id: 132, name: "Davanagere" },
    { country_id: 1, state_id: 17, city_id: 133, name: "Dharwad" },
    { country_id: 1, state_id: 17, city_id: 134, name: "Hassan" },
    { country_id: 1, state_id: 17, city_id: 135, name: "Kalaburagi" },
    { country_id: 1, state_id: 17, city_id: 136, name: "Kodagu" },
    { country_id: 1, state_id: 17, city_id: 137, name: "Kolar" },
    { country_id: 1, state_id: 17, city_id: 138, name: "Koppala" },
    { country_id: 1, state_id: 17, city_id: 139, name: "Mandya" },
    { country_id: 1, state_id: 17, city_id: 140, name: "Mangalore" },
    { country_id: 1, state_id: 17, city_id: 141, name: "Mysuru" },
    { country_id: 1, state_id: 17, city_id: 142, name: "New Udupi" },
    { country_id: 1, state_id: 17, city_id: 143, name: "Raichur" },
    { country_id: 1, state_id: 17, city_id: 144, name: "Ramanagara" },
    { country_id: 1, state_id: 17, city_id: 145, name: "Shimoga" },
    { country_id: 1, state_id: 17, city_id: 147, name: "Tumkur" },
    { country_id: 1, state_id: 17, city_id: 148, name: "Udupi" },
    { country_id: 1, state_id: 17, city_id: 149, name: "Uttara Kannada" },
    { country_id: 1, state_id: 17, city_id: 150, name: "Vijayanagara" },
    { country_id: 1, state_id: 18, city_id: 151, name: "Alappuzha" },
    { country_id: 1, state_id: 18, city_id: 152, name: "Calicut" },
    { country_id: 1, state_id: 18, city_id: 153, name: "Cochin" },
    { country_id: 1, state_id: 18, city_id: 154, name: "Ernakulam" },
    { country_id: 1, state_id: 18, city_id: 155, name: "Idukki" },
    { country_id: 1, state_id: 18, city_id: 156, name: "JUBAIl" },
    { country_id: 1, state_id: 18, city_id: 157, name: "Kakkanad Kochi" },
    { country_id: 1, state_id: 18, city_id: 158, name: "Kannur" },
    { country_id: 1, state_id: 18, city_id: 159, name: "Kasaragod" },
    { country_id: 1, state_id: 18, city_id: 160, name: "Kochi" },
    { country_id: 1, state_id: 18, city_id: 161, name: "Kollam" },
    { country_id: 1, state_id: 18, city_id: 162, name: "Kottayam" },
    { country_id: 1, state_id: 18, city_id: 163, name: "Kozhikode" },
    { country_id: 1, state_id: 18, city_id: 164, name: "Kuala Lumpur" },
    { country_id: 1, state_id: 18, city_id: 165, name: "Malappuram" },
    { country_id: 1, state_id: 18, city_id: 166, name: "Palakkad" },
    { country_id: 1, state_id: 18, city_id: 167, name: "Palghat" },
    { country_id: 1, state_id: 18, city_id: 168, name: "Pathanamthitta" },
    { country_id: 1, state_id: 18, city_id: 169, name: "Thiruvananthapuram" },
    { country_id: 1, state_id: 18, city_id: 170, name: "Thrissur" },
    { country_id: 1, state_id: 18, city_id: 171, name: "Tiruvalla" },
    { country_id: 1, state_id: 18, city_id: 172, name: "Vadakara" },
    { country_id: 1, state_id: 18, city_id: 173, name: "Wayanad" },
    { country_id: 1, state_id: 19, city_id: 174, name: "Leh" },
    { country_id: 1, state_id: 20, city_id: 175, name: "Balaghat" },
    { country_id: 1, state_id: 20, city_id: 176, name: "Betul" },
    { country_id: 1, state_id: 20, city_id: 177, name: "Bhopal" },
    { country_id: 1, state_id: 20, city_id: 178, name: "Burhanpur" },
    { country_id: 1, state_id: 20, city_id: 179, name: "Chhatarpur" },
    { country_id: 1, state_id: 20, city_id: 180, name: "Chhindwara" },
    { country_id: 1, state_id: 20, city_id: 181, name: "Dewas" },
    { country_id: 1, state_id: 20, city_id: 182, name: "Dhar" },
    { country_id: 1, state_id: 20, city_id: 183, name: "Gwalior" },
    { country_id: 1, state_id: 20, city_id: 184, name: "Hoshangabad" },
    { country_id: 1, state_id: 20, city_id: 185, name: "Indore" },
    { country_id: 1, state_id: 20, city_id: 186, name: "Jabalpur" },
    { country_id: 1, state_id: 20, city_id: 187, name: "Katni" },
    { country_id: 1, state_id: 20, city_id: 188, name: "Khargone" },
    { country_id: 1, state_id: 20, city_id: 189, name: "Mandla" },
    { country_id: 1, state_id: 20, city_id: 190, name: "Mandsaur" },
    { country_id: 1, state_id: 20, city_id: 191, name: "Morena" },
    { country_id: 1, state_id: 20, city_id: 192, name: "Raisen" },
    { country_id: 1, state_id: 20, city_id: 193, name: "Rajgarh" },
    { country_id: 1, state_id: 20, city_id: 194, name: "Ratlam" },
    { country_id: 1, state_id: 20, city_id: 195, name: "Rewa" },
    { country_id: 1, state_id: 20, city_id: 196, name: "Sagar" },
    { country_id: 1, state_id: 20, city_id: 197, name: "Satna" },
    { country_id: 1, state_id: 20, city_id: 198, name: "Tikamgarh" },
    { country_id: 1, state_id: 20, city_id: 199, name: "Ujjain" },
    { country_id: 1, state_id: 21, city_id: 200, name: "Mumbai" },
    { country_id: 1, state_id: 21, city_id: 201, name: "Ahmednagar" },
    { country_id: 1, state_id: 21, city_id: 202, name: "Akola" },
    { country_id: 1, state_id: 21, city_id: 203, name: "Amravati" },
    { country_id: 1, state_id: 21, city_id: 204, name: "Aurangabad" },
    { country_id: 1, state_id: 21, city_id: 205, name: "Buldhana" },
    { country_id: 1, state_id: 21, city_id: 206, name: "Dhule" },
    { country_id: 1, state_id: 21, city_id: 207, name: "Dombivli East" },
    { country_id: 1, state_id: 21, city_id: 208, name: "Jalgaon" },
    { country_id: 1, state_id: 21, city_id: 209, name: "Jalna" },
    { country_id: 1, state_id: 21, city_id: 210, name: "Kolhapur" },
    { country_id: 1, state_id: 21, city_id: 211, name: "Latur" },
    { country_id: 1, state_id: 21, city_id: 212, name: "Lonavala" },
    { country_id: 1, state_id: 21, city_id: 213, name: "Nagaur" },
    { country_id: 1, state_id: 21, city_id: 214, name: "Nanded" },
    { country_id: 1, state_id: 21, city_id: 215, name: "Nasik" },
    { country_id: 1, state_id: 21, city_id: 216, name: "Navi Mumbai" },
    { country_id: 1, state_id: 21, city_id: 217, name: "Osmanabad" },
    { country_id: 1, state_id: 21, city_id: 218, name: "Palghar" },
    { country_id: 1, state_id: 21, city_id: 219, name: "Pune" },
    { country_id: 1, state_id: 21, city_id: 220, name: "Raigad" },
    { country_id: 1, state_id: 21, city_id: 221, name: "Ratnagiri" },
    { country_id: 1, state_id: 21, city_id: 222, name: "Sangli" },
    { country_id: 1, state_id: 21, city_id: 223, name: "Satara" },
    { country_id: 1, state_id: 21, city_id: 224, name: "Shahapur" },
    { country_id: 1, state_id: 21, city_id: 225, name: "Solapur" },
    { country_id: 1, state_id: 21, city_id: 226, name: "Valsad" },
    { country_id: 1, state_id: 22, city_id: 227, name: "Virar" },
    { country_id: 1, state_id: 22, city_id: 228, name: "Imphal West" },
    { country_id: 1, state_id: 22, city_id: 229, name: "Churachandpur" },
    { country_id: 1, state_id: 22, city_id: 230, name: "Ukhrul" },
    { country_id: 1, state_id: 23, city_id: 231, name: "Shillong" },
    { country_id: 1, state_id: 23, city_id: 232, name: "CherraPunji" },
    { country_id: 1, state_id: 24, city_id: 233, name: "Aizwal" },
    { country_id: 1, state_id: 25, city_id: 234, name: "Dimapur" },
    { country_id: 1, state_id: 25, city_id: 235, name: "Kohima" },
    { country_id: 1, state_id: 26, city_id: 236, name: "Baleswar" },
    { country_id: 1, state_id: 26, city_id: 237, name: "Bhubaneshwar" },
    { country_id: 1, state_id: 26, city_id: 238, name: "Rourkela" },
    { country_id: 1, state_id: 26, city_id: 239, name: "Cuttack" },
    { country_id: 1, state_id: 26, city_id: 240, name: "Dhenkanal" },
    { country_id: 1, state_id: 26, city_id: 241, name: "Jagatsinghpur" },
    { country_id: 1, state_id: 26, city_id: 242, name: "Jharsuguda" },
    { country_id: 1, state_id: 26, city_id: 243, name: "Kendujhar" },
    { country_id: 1, state_id: 26, city_id: 244, name: "Khordha" },
    { country_id: 1, state_id: 26, city_id: 245, name: "Koraput" },
    { country_id: 1, state_id: 26, city_id: 246, name: "Puri" },
    { country_id: 1, state_id: 26, city_id: 247, name: "Rayagada" },
    { country_id: 1, state_id: 26, city_id: 248, name: "Sambalpur" },
    { country_id: 1, state_id: 26, city_id: 249, name: "Sundargarh" },
    { country_id: 1, state_id: 27, city_id: 250, name: "Pondicherry" },
    { country_id: 1, state_id: 28, city_id: 251, name: "Amritsar" },
    { country_id: 1, state_id: 28, city_id: 252, name: "Bahawalpur" },
    { country_id: 1, state_id: 28, city_id: 253, name: "Bathinda" },
    { country_id: 1, state_id: 28, city_id: 254, name: "Chandigarh" },
    { country_id: 1, state_id: 28, city_id: 255, name: "Faridkot" },
    { country_id: 1, state_id: 28, city_id: 256, name: "Fatehgarh Sahib" },
    { country_id: 1, state_id: 28, city_id: 257, name: "Gurdaspur" },
    { country_id: 1, state_id: 28, city_id: 258, name: "Hoshiarpur" },
    { country_id: 1, state_id: 28, city_id: 259, name: "Jalandhar" },
    { country_id: 1, state_id: 28, city_id: 260, name: "Kapurthala" },
    { country_id: 1, state_id: 28, city_id: 261, name: "Kasur" },
    { country_id: 1, state_id: 28, city_id: 262, name: "Lahore" },
    { country_id: 1, state_id: 28, city_id: 263, name: "Ludhiana" },
    { country_id: 1, state_id: 28, city_id: 264, name: "Mohali" },
    { country_id: 1, state_id: 28, city_id: 265, name: "Pathankot" },
    { country_id: 1, state_id: 28, city_id: 266, name: "Patiala" },
    { country_id: 1, state_id: 28, city_id: 267, name: "Rupnagar" },
    { country_id: 1, state_id: 28, city_id: 268, name: "Sangrur" },
    { country_id: 1, state_id: 28, city_id: 269, name: "Sri Muktsar Sahib" },
    { country_id: 1, state_id: 29, city_id: 270, name: "Ajmer" },
    { country_id: 1, state_id: 29, city_id: 271, name: "Alwar" },
    { country_id: 1, state_id: 29, city_id: 272, name: "Banswara" },
    { country_id: 1, state_id: 29, city_id: 273, name: "Barmer" },
    { country_id: 1, state_id: 29, city_id: 274, name: "Bharatpur" },
    { country_id: 1, state_id: 29, city_id: 275, name: "Bhilwara" },
    { country_id: 1, state_id: 29, city_id: 276, name: "Bhiwadi" },
    { country_id: 1, state_id: 29, city_id: 277, name: "Bikaner" },
    { country_id: 1, state_id: 29, city_id: 278, name: "Chittorgarh" },
    { country_id: 1, state_id: 29, city_id: 279, name: "Jaipur" },
    { country_id: 1, state_id: 29, city_id: 280, name: "Jaisalmer" },
    { country_id: 1, state_id: 29, city_id: 281, name: "Jhalawar" },
    { country_id: 1, state_id: 29, city_id: 282, name: "Jhunjhunu" },
    { country_id: 1, state_id: 29, city_id: 283, name: "Jodhpur" },
    { country_id: 1, state_id: 29, city_id: 284, name: "Kota" },
    { country_id: 1, state_id: 29, city_id: 285, name: "Nagaur" },
    { country_id: 1, state_id: 29, city_id: 286, name: "Pali" },
    { country_id: 1, state_id: 29, city_id: 287, name: "Rajsamand" },
    { country_id: 1, state_id: 29, city_id: 288, name: "Sawai Madhopur" },
    { country_id: 1, state_id: 29, city_id: 289, name: "Sikar" },
    { country_id: 1, state_id: 29, city_id: 290, name: "Sirohi" },
    { country_id: 1, state_id: 29, city_id: 291, name: "Sri Ganganagar" },
    { country_id: 1, state_id: 29, city_id: 292, name: "Udaipur" },
    { country_id: 1, state_id: 30, city_id: 293, name: "Gangtok" },
    { country_id: 1, state_id: 31, city_id: 294, name: "Ariyalur" },
    { country_id: 1, state_id: 31, city_id: 295, name: "Chattanooga" },
    { country_id: 1, state_id: 31, city_id: 296, name: "Chengalpattu" },
    { country_id: 1, state_id: 31, city_id: 297, name: "Chennai" },
    { country_id: 1, state_id: 31, city_id: 298, name: "Coimbatore" },
    { country_id: 1, state_id: 31, city_id: 299, name: "Cuddalore" },
    { country_id: 1, state_id: 31, city_id: 300, name: "Dindigul" },
    { country_id: 1, state_id: 31, city_id: 301, name: "Erode" },
    { country_id: 1, state_id: 31, city_id: 302, name: "Hosur" },
    { country_id: 1, state_id: 31, city_id: 303, name: "Kanchipuram" },
    { country_id: 1, state_id: 31, city_id: 304, name: "Kanyakumari" },
    { country_id: 1, state_id: 31, city_id: 305, name: "Karur" },
    { country_id: 1, state_id: 31, city_id: 306, name: "Krishnagiri" },
    { country_id: 1, state_id: 31, city_id: 307, name: "Madurai" },
    { country_id: 1, state_id: 31, city_id: 308, name: "Mayiladuthurai" },
    { country_id: 1, state_id: 31, city_id: 309, name: "Nagapattinam" },
    { country_id: 1, state_id: 31, city_id: 310, name: "Namakkal" },
    { country_id: 1, state_id: 31, city_id: 311, name: "Nilgiris" },
    { country_id: 1, state_id: 31, city_id: 312, name: "Pudukkottai" },
    { country_id: 1, state_id: 31, city_id: 313, name: "Ranipet" },
    { country_id: 1, state_id: 31, city_id: 314, name: "Salem" },
    { country_id: 1, state_id: 31, city_id: 315, name: "Thanjavur" },
    { country_id: 1, state_id: 31, city_id: 316, name: "Thiruvallur" },
    { country_id: 1, state_id: 31, city_id: 317, name: "Thoothukudi" },
    { country_id: 1, state_id: 31, city_id: 318, name: "Tiruchirappalli" },
    { country_id: 1, state_id: 31, city_id: 319, name: "Tirunelveli" },
    { country_id: 1, state_id: 31, city_id: 320, name: "Tirupathur" },
    { country_id: 1, state_id: 31, city_id: 321, name: "Tiruppur" },
    { country_id: 1, state_id: 31, city_id: 322, name: "Tiruvallur" },
    { country_id: 1, state_id: 31, city_id: 323, name: "Tiruvannamalai" },
    { country_id: 1, state_id: 31, city_id: 324, name: "Vellore" },
    { country_id: 1, state_id: 31, city_id: 325, name: "Viluppuram" },
    { country_id: 1, state_id: 31, city_id: 326, name: "Virudhunagar" },
    { country_id: 1, state_id: 32, city_id: 327, name: "Adilabad" },
    { country_id: 1, state_id: 32, city_id: 328, name: "Bhadradri Kothagudem" },
    { country_id: 1, state_id: 32, city_id: 329, name: "Hyderabad" },
    { country_id: 1, state_id: 32, city_id: 330, name: "Janjgir–Champa" },
    { country_id: 1, state_id: 32, city_id: 331, name: "Karimnagar" },
    { country_id: 1, state_id: 32, city_id: 332, name: "Khammam" },
    { country_id: 1, state_id: 32, city_id: 333, name: "Medak" },
    { country_id: 1, state_id: 32, city_id: 334, name: "Medchal–Malkajgiri" },
    { country_id: 1, state_id: 32, city_id: 335, name: "Nalgonda" },
    { country_id: 1, state_id: 32, city_id: 336, name: "Nizamabad" },
    { country_id: 1, state_id: 32, city_id: 337, name: "Peddapalli" },
    { country_id: 1, state_id: 32, city_id: 338, name: "Ranga Reddy" },
    { country_id: 1, state_id: 32, city_id: 339, name: "Sangareddy" },
    { country_id: 1, state_id: 32, city_id: 340, name: "Warangal" },
    { country_id: 1, state_id: 33, city_id: 341, name: "Agartala" },
    { country_id: 1, state_id: 34, city_id: 342, name: "Agra" },
    { country_id: 1, state_id: 34, city_id: 343, name: "Aligarh" },
    { country_id: 1, state_id: 34, city_id: 344, name: "Amroha" },
    { country_id: 1, state_id: 34, city_id: 345, name: "Ayodhya" },
    { country_id: 1, state_id: 34, city_id: 346, name: "Azamgarh" },
    { country_id: 1, state_id: 34, city_id: 347, name: "Baghpat" },
    { country_id: 1, state_id: 34, city_id: 348, name: "Barabanki" },
    { country_id: 1, state_id: 34, city_id: 349, name: "Bareilly" },
    { country_id: 1, state_id: 34, city_id: 350, name: "Bhadohi" },
    { country_id: 1, state_id: 34, city_id: 351, name: "Bijnor" },
    { country_id: 1, state_id: 34, city_id: 352, name: "Budaun" },
    { country_id: 1, state_id: 34, city_id: 353, name: "Bulandshahr" },
    { country_id: 1, state_id: 34, city_id: 354, name: "Etah" },
    { country_id: 1, state_id: 34, city_id: 355, name: "Faridabad" },
    { country_id: 1, state_id: 34, city_id: 356, name: "Firozabad" },
    { country_id: 1, state_id: 34, city_id: 357, name: "Gautam Budh Nagar" },
    { country_id: 1, state_id: 34, city_id: 358, name: "Ghaziabad" },
    { country_id: 1, state_id: 34, city_id: 359, name: "Gorakhpur" },
    { country_id: 1, state_id: 34, city_id: 360, name: "Greater Noida" },
    { country_id: 1, state_id: 34, city_id: 361, name: "Hapur" },
    { country_id: 1, state_id: 34, city_id: 362, name: "Jhansi" },
    { country_id: 1, state_id: 34, city_id: 363, name: "Kanpur" },
    { country_id: 1, state_id: 34, city_id: 364, name: "Kanpur Nagar" },
    { country_id: 1, state_id: 34, city_id: 365, name: "Lucknow" },
    { country_id: 1, state_id: 34, city_id: 366, name: "Mathura" },
    { country_id: 1, state_id: 34, city_id: 367, name: "Meerut" },
    { country_id: 1, state_id: 34, city_id: 368, name: "Mirzapur" },
    { country_id: 1, state_id: 34, city_id: 369, name: "Moradabad" },
    { country_id: 1, state_id: 34, city_id: 370, name: "Muzaffarnagar" },
    { country_id: 1, state_id: 34, city_id: 371, name: "Noida" },
    { country_id: 1, state_id: 34, city_id: 372, name: "Pilibhit" },
    { country_id: 1, state_id: 34, city_id: 373, name: "Prayagraj" },
    { country_id: 1, state_id: 34, city_id: 374, name: "Raebareli" },
    { country_id: 1, state_id: 34, city_id: 375, name: "Rampur" },
    { country_id: 1, state_id: 34, city_id: 376, name: "Saharanpur" },
    { country_id: 1, state_id: 34, city_id: 377, name: "Sahibabad" },
    { country_id: 1, state_id: 34, city_id: 378, name: "Shahjahanpur" },
    { country_id: 1, state_id: 34, city_id: 379, name: "Sitapur" },
    { country_id: 1, state_id: 34, city_id: 380, name: "Varanasi" },
    { country_id: 1, state_id: 35, city_id: 381, name: "Almora" },
    { country_id: 1, state_id: 35, city_id: 382, name: "Dehradun" },
    { country_id: 1, state_id: 35, city_id: 383, name: "Haridwar" },
    { country_id: 1, state_id: 35, city_id: 384, name: "Nainital" },
    { country_id: 1, state_id: 35, city_id: 385, name: "Pauri Garhwal" },
    { country_id: 1, state_id: 35, city_id: 386, name: "Rudra Prayag" },
    { country_id: 1, state_id: 35, city_id: 387, name: "Tehri Garhwal" },
    { country_id: 1, state_id: 35, city_id: 388, name: "Mussorie" },
    { country_id: 1, state_id: 35, city_id: 389, name: "Udham Singh Nagar" },
    { country_id: 1, state_id: 36, city_id: 390, name: "Bankura" },
    { country_id: 1, state_id: 36, city_id: 391, name: "Birbhum" },
    { country_id: 1, state_id: 36, city_id: 392, name: "Darjeeling" },
    { country_id: 1, state_id: 36, city_id: 393, name: "Hooghly" },
    { country_id: 1, state_id: 36, city_id: 394, name: "Jalpaiguri" },
    { country_id: 1, state_id: 36, city_id: 395, name: "Kolkata" },
    { country_id: 1, state_id: 36, city_id: 396, name: "Kozhikode" },
    { country_id: 1, state_id: 36, city_id: 397, name: "Nadia" },
    { country_id: 1, state_id: 36, city_id: 398, name: "North 24 Parganas" },
    { country_id: 1, state_id: 36, city_id: 399, name: "Purba Bardhaman" },
    { country_id: 1, state_id: 36, city_id: 400, name: "Purba Medinipur" },
    { country_id: 1, state_id: 36, city_id: 401, name: "Uttar Dinajpur" },
    { country_id: 1, state_id: 36, city_id: 402, name: "West Medinipur" },

    // Alabama
    { country_id: 2, state_id: 1, city_id: 1, name: "Birmingham" },
    { country_id: 2, state_id: 1, city_id: 2, name: "Montgomery" },
    { country_id: 2, state_id: 1, city_id: 3, name: "Huntsville" },
    { country_id: 2, state_id: 1, city_id: 4, name: "Mobile" },
    { country_id: 2, state_id: 1, city_id: 5, name: "Tuscaloosa" },
    { country_id: 2, state_id: 1, city_id: 6, name: "Auburn" },
    { country_id: 2, state_id: 1, city_id: 7, name: "Dothan" },
    { country_id: 2, state_id: 1, city_id: 8, name: "Decatur" },
    { country_id: 2, state_id: 1, city_id: 9, name: "Florence" },
    { country_id: 2, state_id: 1, city_id: 10, name: "Madison" },

    // Alaska
    { country_id: 2, state_id: 2, city_id: 11, name: "Anchorage" },
    { country_id: 2, state_id: 2, city_id: 12, name: "Fairbanks" },
    { country_id: 2, state_id: 2, city_id: 13, name: "Juneau" },
    { country_id: 2, state_id: 2, city_id: 14, name: "Sitka" },
    { country_id: 2, state_id: 2, city_id: 15, name: "Ketchikan" },
    { country_id: 2, state_id: 2, city_id: 16, name: "Wasilla" },
    { country_id: 2, state_id: 2, city_id: 17, name: "Kenai" },
    { country_id: 2, state_id: 2, city_id: 18, name: "Kodiak" },
    { country_id: 2, state_id: 2, city_id: 19, name: "Palmer" },
    { country_id: 2, state_id: 2, city_id: 20, name: "Bethel" },

    // Arizona
    { country_id: 2, state_id: 3, city_id: 21, name: "Phoenix" },
    { country_id: 2, state_id: 3, city_id: 22, name: "Tucson" },
    { country_id: 2, state_id: 3, city_id: 23, name: "Mesa" },
    { country_id: 2, state_id: 3, city_id: 24, name: "Chandler" },
    { country_id: 2, state_id: 3, city_id: 25, name: "Glendale" },
    { country_id: 2, state_id: 3, city_id: 26, name: "Scottsdale" },
    { country_id: 2, state_id: 3, city_id: 27, name: "Gilbert" },
    { country_id: 2, state_id: 3, city_id: 28, name: "Tempe" },
    { country_id: 2, state_id: 3, city_id: 29, name: "Peoria" },
    { country_id: 2, state_id: 3, city_id: 30, name: "Surprise" },

    // Arkansas
    { country_id: 2, state_id: 4, city_id: 31, name: "Little Rock" },
    { country_id: 2, state_id: 4, city_id: 32, name: "Fort Smith" },
    { country_id: 2, state_id: 4, city_id: 33, name: "Fayetteville" },
    { country_id: 2, state_id: 4, city_id: 34, name: "Springdale" },
    { country_id: 2, state_id: 4, city_id: 35, name: "Jonesboro" },
    { country_id: 2, state_id: 4, city_id: 36, name: "North Little Rock" },
    { country_id: 2, state_id: 4, city_id: 37, name: "Conway" },
    { country_id: 2, state_id: 4, city_id: 38, name: "Rogers" },
    { country_id: 2, state_id: 4, city_id: 39, name: "Bentonville" },
    { country_id: 2, state_id: 4, city_id: 40, name: "Pine Bluff" },

    // California
    { country_id: 2, state_id: 5, city_id: 41, name: "Los Angeles" },
    { country_id: 2, state_id: 5, city_id: 42, name: "San Francisco" },
    { country_id: 2, state_id: 5, city_id: 43, name: "San Diego" },
    { country_id: 2, state_id: 5, city_id: 44, name: "San Jose" },
    { country_id: 2, state_id: 5, city_id: 45, name: "Fresno" },
    { country_id: 2, state_id: 5, city_id: 46, name: "Sacramento" },
    { country_id: 2, state_id: 5, city_id: 47, name: "Long Beach" },
    { country_id: 2, state_id: 5, city_id: 48, name: "Oakland" },
    { country_id: 2, state_id: 5, city_id: 49, name: "Bakersfield" },
    { country_id: 2, state_id: 5, city_id: 50, name: "Anaheim" },

    // Colorado
    { country_id: 2, state_id: 6, city_id: 51, name: "Denver" },
    { country_id: 2, state_id: 6, city_id: 52, name: "Colorado Springs" },
    { country_id: 2, state_id: 6, city_id: 53, name: "Aurora" },
    { country_id: 2, state_id: 6, city_id: 54, name: "Fort Collins" },
    { country_id: 2, state_id: 6, city_id: 55, name: "Lakewood" },
    { country_id: 2, state_id: 6, city_id: 56, name: "Thornton" },
    { country_id: 2, state_id: 6, city_id: 57, name: "Arvada" },
    { country_id: 2, state_id: 6, city_id: 58, name: "Westminster" },
    { country_id: 2, state_id: 6, city_id: 59, name: "Pueblo" },
    { country_id: 2, state_id: 6, city_id: 60, name: "Centennial" },

    // Connecticut
    { country_id: 2, state_id: 7, city_id: 61, name: "Bridgeport" },
    { country_id: 2, state_id: 7, city_id: 62, name: "New Haven" },
    { country_id: 2, state_id: 7, city_id: 63, name: "Stamford" },
    { country_id: 2, state_id: 7, city_id: 64, name: "Hartford" },
    { country_id: 2, state_id: 7, city_id: 65, name: "Waterbury" },
    { country_id: 2, state_id: 7, city_id: 66, name: "Norwalk" },
    { country_id: 2, state_id: 7, city_id: 67, name: "Danbury" },
    { country_id: 2, state_id: 7, city_id: 68, name: "New Britain" },
    { country_id: 2, state_id: 7, city_id: 69, name: "Greenwich" },
    { country_id: 2, state_id: 7, city_id: 70, name: "Bristol" },

    // Delaware
    { country_id: 2, state_id: 8, city_id: 71, name: "Wilmington" },
    { country_id: 2, state_id: 8, city_id: 72, name: "Dover" },
    { country_id: 2, state_id: 8, city_id: 73, name: "Newark" },
    { country_id: 2, state_id: 8, city_id: 74, name: "Middletown" },
    { country_id: 2, state_id: 8, city_id: 75, name: "Smyrna" },
    { country_id: 2, state_id: 8, city_id: 76, name: "Milford" },
    { country_id: 2, state_id: 8, city_id: 77, name: "Seaford" },
    { country_id: 2, state_id: 8, city_id: 78, name: "Georgetown" },
    { country_id: 2, state_id: 8, city_id: 79, name: "Lewes" },
    { country_id: 2, state_id: 8, city_id: 80, name: "Rehoboth Beach" },

    // Florida
    { country_id: 2, state_id: 9, city_id: 81, name: "Jacksonville" },
    { country_id: 2, state_id: 9, city_id: 82, name: "Miami" },
    { country_id: 2, state_id: 9, city_id: 83, name: "Tampa" },
    { country_id: 2, state_id: 9, city_id: 84, name: "Orlando" },
    { country_id: 2, state_id: 9, city_id: 85, name: "St. Petersburg" },
    { country_id: 2, state_id: 9, city_id: 86, name: "Hialeah" },
    { country_id: 2, state_id: 9, city_id: 87, name: "Port St. Lucie" },
    { country_id: 2, state_id: 9, city_id: 88, name: "Tallahassee" },
    { country_id: 2, state_id: 9, city_id: 89, name: "Fort Lauderdale" },
    { country_id: 2, state_id: 9, city_id: 90, name: "Pembroke Pines" },

    // Georgia
    { country_id: 2, state_id: 10, city_id: 91, name: "Atlanta" },
    { country_id: 2, state_id: 10, city_id: 92, name: "Augusta" },
    { country_id: 2, state_id: 10, city_id: 93, name: "Columbus" },
    { country_id: 2, state_id: 10, city_id: 94, name: "Macon" },
    { country_id: 2, state_id: 10, city_id: 95, name: "Savannah" },
    { country_id: 2, state_id: 10, city_id: 96, name: "Athens" },
    { country_id: 2, state_id: 10, city_id: 97, name: "Sandy Springs" },
    { country_id: 2, state_id: 10, city_id: 98, name: "Roswell" },
    { country_id: 2, state_id: 10, city_id: 99, name: "Johns Creek" },
    { country_id: 2, state_id: 10, city_id: 100, name: "Albany" },

    // Hawaii
    { country_id: 2, state_id: 11, city_id: 101, name: "Honolulu" },
    { country_id: 2, state_id: 11, city_id: 102, name: "Hilo" },
    { country_id: 2, state_id: 11, city_id: 103, name: "Kailua" },
    { country_id: 2, state_id: 11, city_id: 104, name: "Kapolei" },
    { country_id: 2, state_id: 11, city_id: 105, name: "Kaneohe" },
    { country_id: 2, state_id: 11, city_id: 106, name: "Pearl City" },
    { country_id: 2, state_id: 11, city_id: 107, name: "Waipahu" },
    { country_id: 2, state_id: 11, city_id: 108, name: "Mililani Town" },
    { country_id: 2, state_id: 11, city_id: 109, name: "Makakilo City" },
    { country_id: 2, state_id: 11, city_id: 110, name: "Kihei" },

    // Idaho
    { country_id: 2, state_id: 12, city_id: 111, name: "Boise" },
    { country_id: 2, state_id: 12, city_id: 112, name: "Meridian" },
    { country_id: 2, state_id: 12, city_id: 113, name: "Nampa" },
    { country_id: 2, state_id: 12, city_id: 114, name: "Idaho Falls" },
    { country_id: 2, state_id: 12, city_id: 115, name: "Caldwell" },
    { country_id: 2, state_id: 12, city_id: 116, name: "Pocatello" },
    { country_id: 2, state_id: 12, city_id: 117, name: "Twin Falls" },
    { country_id: 2, state_id: 12, city_id: 118, name: "Coeur d'Alene" },
    { country_id: 2, state_id: 12, city_id: 119, name: "Lewiston" },
    { country_id: 2, state_id: 12, city_id: 120, name: "Post Falls" },

    // Illinois
    { country_id: 2, state_id: 13, city_id: 121, name: "Chicago" },
    { country_id: 2, state_id: 13, city_id: 122, name: "Aurora" },
    { country_id: 2, state_id: 13, city_id: 123, name: "Naperville" },
    { country_id: 2, state_id: 13, city_id: 124, name: "Joliet" },
    { country_id: 2, state_id: 13, city_id: 125, name: "Rockford" },
    { country_id: 2, state_id: 13, city_id: 126, name: "Springfield" },
    { country_id: 2, state_id: 13, city_id: 127, name: "Peoria" },
    { country_id: 2, state_id: 13, city_id: 128, name: "Elgin" },
    { country_id: 2, state_id: 13, city_id: 129, name: "Waukegan" },
    { country_id: 2, state_id: 13, city_id: 130, name: "Cicero" },

    // Indiana
    { country_id: 2, state_id: 14, city_id: 131, name: "Indianapolis" },
    { country_id: 2, state_id: 14, city_id: 132, name: "Fort Wayne" },
    { country_id: 2, state_id: 14, city_id: 133, name: "Evansville" },
    { country_id: 2, state_id: 14, city_id: 134, name: "South Bend" },
    { country_id: 2, state_id: 14, city_id: 135, name: "Carmel" },
    { country_id: 2, state_id: 14, city_id: 136, name: "Fishers" },
    { country_id: 2, state_id: 14, city_id: 137, name: "Bloomington" },
    { country_id: 2, state_id: 14, city_id: 138, name: "Hammond" },
    { country_id: 2, state_id: 14, city_id: 139, name: "Gary" },
    { country_id: 2, state_id: 14, city_id: 140, name: "Lafayette" },

    // Iowa
    { country_id: 2, state_id: 15, city_id: 141, name: "Des Moines" },
    { country_id: 2, state_id: 15, city_id: 142, name: "Cedar Rapids" },
    { country_id: 2, state_id: 15, city_id: 143, name: "Davenport" },
    { country_id: 2, state_id: 15, city_id: 144, name: "Sioux City" },
    { country_id: 2, state_id: 15, city_id: 145, name: "Iowa City" },
    { country_id: 2, state_id: 15, city_id: 146, name: "Waterloo" },
    { country_id: 2, state_id: 15, city_id: 147, name: "Ames" },
    { country_id: 2, state_id: 15, city_id: 148, name: "West Des Moines" },
    { country_id: 2, state_id: 15, city_id: 149, name: "Dubuque" },
    { country_id: 2, state_id: 15, city_id: 150, name: "Council Bluffs" },

    // Kansas
    { country_id: 2, state_id: 16, city_id: 151, name: "Wichita" },
    { country_id: 2, state_id: 16, city_id: 152, name: "Overland Park" },
    { country_id: 2, state_id: 16, city_id: 153, name: "Kansas City" },
    { country_id: 2, state_id: 16, city_id: 154, name: "Topeka" },
    { country_id: 2, state_id: 16, city_id: 155, name: "Olathe" },
    { country_id: 2, state_id: 16, city_id: 156, name: "Lawrence" },
    { country_id: 2, state_id: 16, city_id: 157, name: "Shawnee" },
    { country_id: 2, state_id: 16, city_id: 158, name: "Manhattan" },
    { country_id: 2, state_id: 16, city_id: 159, name: "Lenexa" },
    { country_id: 2, state_id: 16, city_id: 160, name: "Salina" },

    // Kentucky
    { country_id: 2, state_id: 17, city_id: 161, name: "Louisville" },
    { country_id: 2, state_id: 17, city_id: 162, name: "Lexington" },
    { country_id: 2, state_id: 17, city_id: 163, name: "Bowling Green" },
    { country_id: 2, state_id: 17, city_id: 164, name: "Owensboro" },
    { country_id: 2, state_id: 17, city_id: 165, name: "Covington" },
    { country_id: 2, state_id: 17, city_id: 166, name: "Hopkinsville" },
    { country_id: 2, state_id: 17, city_id: 167, name: "Richmond" },
    { country_id: 2, state_id: 17, city_id: 168, name: "Florence" },
    { country_id: 2, state_id: 17, city_id: 169, name: "Georgetown" },
    { country_id: 2, state_id: 17, city_id: 170, name: "Independence" },

    // Louisiana
    { country_id: 2, state_id: 18, city_id: 171, name: "New Orleans" },
    { country_id: 2, state_id: 18, city_id: 172, name: "Baton Rouge" },
    { country_id: 2, state_id: 18, city_id: 173, name: "Shreveport" },
    { country_id: 2, state_id: 18, city_id: 174, name: "Lafayette" },
    { country_id: 2, state_id: 18, city_id: 175, name: "Lake Charles" },
    { country_id: 2, state_id: 18, city_id: 176, name: "Kenner" },
    { country_id: 2, state_id: 18, city_id: 177, name: "Bossier City" },
    { country_id: 2, state_id: 18, city_id: 178, name: "Monroe" },
    { country_id: 2, state_id: 18, city_id: 179, name: "Alexandria, Louisiana" },
    { country_id: 2, state_id: 18, city_id: 180, name: "Houma" },

    // Maine
    { country_id: 2, state_id: 19, city_id: 181, name: "Portland" },
    { country_id: 2, state_id: 19, city_id: 182, name: "Lewiston" },
    { country_id: 2, state_id: 19, city_id: 183, name: "Bangor" },
    { country_id: 2, state_id: 19, city_id: 184, name: "South Portland" },
    { country_id: 2, state_id: 19, city_id: 185, name: "Auburn" },
    { country_id: 2, state_id: 19, city_id: 186, name: "Biddeford" },
    { country_id: 2, state_id: 19, city_id: 187, name: "Sanford" },
    { country_id: 2, state_id: 19, city_id: 188, name: "Augusta" },
    { country_id: 2, state_id: 19, city_id: 189, name: "Saco" },
    { country_id: 2, state_id: 19, city_id: 190, name: "Westbrook" },

    // Maryland
    { country_id: 2, state_id: 20, city_id: 191, name: "Baltimore" },
    { country_id: 2, state_id: 20, city_id: 192, name: "Frederick" },
    { country_id: 2, state_id: 20, city_id: 193, name: "Rockville" },
    { country_id: 2, state_id: 20, city_id: 194, name: "Gaithersburg" },
    { country_id: 2, state_id: 20, city_id: 195, name: "Bowie" },
    { country_id: 2, state_id: 20, city_id: 196, name: "Hagerstown" },
    { country_id: 2, state_id: 20, city_id: 197, name: "Annapolis" },
    { country_id: 2, state_id: 20, city_id: 198, name: "Salisbury" },
    { country_id: 2, state_id: 20, city_id: 199, name: "Laurel" },
    { country_id: 2, state_id: 20, city_id: 200, name: "Columbia" },

    // Massachusetts
    { country_id: 2, state_id: 21, city_id: 201, name: "Boston" },
    { country_id: 2, state_id: 21, city_id: 202, name: "Worcester" },
    { country_id: 2, state_id: 21, city_id: 203, name: "Springfield" },
    { country_id: 2, state_id: 21, city_id: 204, name: "Cambridge" },
    { country_id: 2, state_id: 21, city_id: 205, name: "New Bedford" },
    { country_id: 2, state_id: 21, city_id: 206, name: "Brockton" },
    { country_id: 2, state_id: 21, city_id: 207, name: "Quincy" },
    { country_id: 2, state_id: 21, city_id: 208, name: "Lynn" },
    { country_id: 2, state_id: 21, city_id: 209, name: "Fall River" },
    { country_id: 2, state_id: 21, city_id: 210, name: "Newton" },

    // Michigan
    { country_id: 2, state_id: 22, city_id: 211, name: "Detroit" },
    { country_id: 2, state_id: 22, city_id: 212, name: "Grand Rapids" },
    { country_id: 2, state_id: 22, city_id: 213, name: "Warren" },
    { country_id: 2, state_id: 22, city_id: 214, name: "Sterling Heights" },
    { country_id: 2, state_id: 22, city_id: 215, name: "Ann Arbor" },
    { country_id: 2, state_id: 22, city_id: 216, name: "Lansing" },
    { country_id: 2, state_id: 22, city_id: 217, name: "Flint" },
    { country_id: 2, state_id: 22, city_id: 218, name: "Dearborn" },
    { country_id: 2, state_id: 22, city_id: 219, name: "Livonia" },
    { country_id: 2, state_id: 22, city_id: 220, name: "Westland" },

    // Minnesota
    { country_id: 2, state_id: 23, city_id: 221, name: "Minneapolis" },
    { country_id: 2, state_id: 23, city_id: 222, name: "Saint Paul" },
    { country_id: 2, state_id: 23, city_id: 223, name: "Rochester" },
    { country_id: 2, state_id: 23, city_id: 224, name: "Duluth" },
    { country_id: 2, state_id: 23, city_id: 225, name: "Bloomington" },
    { country_id: 2, state_id: 23, city_id: 226, name: "Plymouth" },
    { country_id: 2, state_id: 23, city_id: 227, name: "Brooklyn Park" },
    { country_id: 2, state_id: 23, city_id: 228, name: "Eagan" },
    { country_id: 2, state_id: 23, city_id: 229, name: "Maple Grove" },
    { country_id: 2, state_id: 23, city_id: 230, name: "Woodbury" },

    // Mississippi
    { country_id: 2, state_id: 24, city_id: 231, name: "Jackson" },
    { country_id: 2, state_id: 24, city_id: 232, name: "Gulfport" },
    { country_id: 2, state_id: 24, city_id: 233, name: "Southaven" },
    { country_id: 2, state_id: 24, city_id: 234, name: "Biloxi" },
    { country_id: 2, state_id: 24, city_id: 235, name: "Hattiesburg" },
    { country_id: 2, state_id: 24, city_id: 236, name: "Meridian" },
    { country_id: 2, state_id: 24, city_id: 237, name: "Tupelo" },
    { country_id: 2, state_id: 24, city_id: 238, name: "Olive Branch" },
    { country_id: 2, state_id: 24, city_id: 239, name: "Greenville" },
    { country_id: 2, state_id: 24, city_id: 240, name: "Horn Lake" },

    // Missouri
    { country_id: 2, state_id: 25, city_id: 241, name: "Kansas City" },
    { country_id: 2, state_id: 25, city_id: 242, name: "St. Louis" },
    { country_id: 2, state_id: 25, city_id: 243, name: "Springfield" },
    { country_id: 2, state_id: 25, city_id: 244, name: "Independence" },
    { country_id: 2, state_id: 25, city_id: 245, name: "Columbia" },
    { country_id: 2, state_id: 25, city_id: 246, name: "Lee's Summit" },
    { country_id: 2, state_id: 25, city_id: 247, name: "O'Fallon" },
    { country_id: 2, state_id: 25, city_id: 248, name: "St. Joseph" },
    { country_id: 2, state_id: 25, city_id: 249, name: "St. Charles" },
    { country_id: 2, state_id: 25, city_id: 250, name: "Blue Springs" },

    // Montana
    { country_id: 2, state_id: 26, city_id: 251, name: "Billings" },
    { country_id: 2, state_id: 26, city_id: 252, name: "Missoula" },
    { country_id: 2, state_id: 26, city_id: 253, name: "Great Falls" },
    { country_id: 2, state_id: 26, city_id: 254, name: "Bozeman" },
    { country_id: 2, state_id: 26, city_id: 255, name: "Butte" },
    { country_id: 2, state_id: 26, city_id: 256, name: "Helena" },
    { country_id: 2, state_id: 26, city_id: 257, name: "Kalispell" },
    { country_id: 2, state_id: 26, city_id: 258, name: "Havre" },
    { country_id: 2, state_id: 26, city_id: 259, name: "Miles City" },

    // Nebraska
    { country_id: 2, state_id: 27, city_id: 260, name: "Omaha" },
    { country_id: 2, state_id: 27, city_id: 261, name: "Lincoln" },
    { country_id: 2, state_id: 27, city_id: 262, name: "Bellevue" },
    { country_id: 2, state_id: 27, city_id: 263, name: "Grand Island" },
    { country_id: 2, state_id: 27, city_id: 264, name: "Kearney" },
    { country_id: 2, state_id: 27, city_id: 265, name: "Fremont" },
    { country_id: 2, state_id: 27, city_id: 266, name: "Hastings" },
    { country_id: 2, state_id: 27, city_id: 267, name: "Norfolk" },
    { country_id: 2, state_id: 27, city_id: 268, name: "Columbus" },
    { country_id: 2, state_id: 27, city_id: 269, name: "North Platte" },

    // Nevada
    { country_id: 2, state_id: 28, city_id: 270, name: "Las Vegas" },
    { country_id: 2, state_id: 28, city_id: 271, name: "Henderson" },
    { country_id: 2, state_id: 28, city_id: 272, name: "Reno" },
    { country_id: 2, state_id: 28, city_id: 273, name: "North Las Vegas" },
    { country_id: 2, state_id: 28, city_id: 274, name: "Sparks" },
    { country_id: 2, state_id: 28, city_id: 275, name: "Carson City" },
    { country_id: 2, state_id: 28, city_id: 276, name: "Elko" },
    { country_id: 2, state_id: 28, city_id: 277, name: "Boulder City" },
    { country_id: 2, state_id: 28, city_id: 278, name: "Fernley" },
    { country_id: 2, state_id: 28, city_id: 279, name: "Mesquite" },

    // New Hampshire
    { country_id: 2, state_id: 29, city_id: 280, name: "Manchester" },
    { country_id: 2, state_id: 29, city_id: 281, name: "Nashua" },
    { country_id: 2, state_id: 29, city_id: 282, name: "Concord" },
    { country_id: 2, state_id: 29, city_id: 283, name: "Derry" },
    { country_id: 2, state_id: 29, city_id: 284, name: "Dover" },
    { country_id: 2, state_id: 29, city_id: 285, name: "Rochester" },
    { country_id: 2, state_id: 29, city_id: 286, name: "Keene" },
    { country_id: 2, state_id: 29, city_id: 287, name: "Portsmouth" },
    { country_id: 2, state_id: 29, city_id: 288, name: "Laconia" },
    { country_id: 2, state_id: 29, city_id: 289, name: "Claremont" },

    // New Jersey
    { country_id: 2, state_id: 30, city_id: 290, name: "Newark" },
    { country_id: 2, state_id: 30, city_id: 291, name: "Jersey City" },
    { country_id: 2, state_id: 30, city_id: 292, name: "Paterson" },
    { country_id: 2, state_id: 30, city_id: 293, name: "Elizabeth" },
    { country_id: 2, state_id: 30, city_id: 294, name: "Edison" },
    { country_id: 2, state_id: 30, city_id: 295, name: "Woodbridge" },
    { country_id: 2, state_id: 30, city_id: 296, name: "Lakewood" },
    { country_id: 2, state_id: 30, city_id: 297, name: "Toms River" },
    { country_id: 2, state_id: 30, city_id: 298, name: "Hamilton" },
    { country_id: 2, state_id: 30, city_id: 299, name: "Trenton" },

    // New Mexico
    { country_id: 2, state_id: 31, city_id: 300, name: "Albuquerque" },
    { country_id: 2, state_id: 31, city_id: 301, name: "Las Cruces" },
    { country_id: 2, state_id: 31, city_id: 302, name: "Rio Rancho" },
    { country_id: 2, state_id: 31, city_id: 303, name: "Santa Fe" },
    { country_id: 2, state_id: 31, city_id: 304, name: "Roswell" },
    { country_id: 2, state_id: 31, city_id: 305, name: "Farmington" },
    { country_id: 2, state_id: 31, city_id: 306, name: "Clovis" },
    { country_id: 2, state_id: 31, city_id: 307, name: "Hobbs" },
    { country_id: 2, state_id: 31, city_id: 308, name: "Alamogordo" },
    { country_id: 2, state_id: 31, city_id: 309, name: "Carlsbad" },

    // New York
    { country_id: 2, state_id: 32, city_id: 310, name: "New York City" },
    { country_id: 2, state_id: 32, city_id: 311, name: "Buffalo" },
    { country_id: 2, state_id: 32, city_id: 312, name: "Rochester" },
    { country_id: 2, state_id: 32, city_id: 313, name: "Yonkers" },
    { country_id: 2, state_id: 32, city_id: 314, name: "Syracuse" },
    { country_id: 2, state_id: 32, city_id: 315, name: "Albany" },
    { country_id: 2, state_id: 32, city_id: 316, name: "New Rochelle" },
    { country_id: 2, state_id: 32, city_id: 317, name: "Mount Vernon" },
    { country_id: 2, state_id: 32, city_id: 318, name: "Schenectady" },
    { country_id: 2, state_id: 32, city_id: 319, name: "Utica" },

    // North Carolina
    { country_id: 2, state_id: 33, city_id: 320, name: "Charlotte" },
    { country_id: 2, state_id: 33, city_id: 321, name: "Raleigh" },
    { country_id: 2, state_id: 33, city_id: 322, name: "Greensboro" },
    { country_id: 2, state_id: 33, city_id: 323, name: "Durham" },
    { country_id: 2, state_id: 33, city_id: 324, name: "Winston-Salem" },
    { country_id: 2, state_id: 33, city_id: 325, name: "Fayetteville" },
    { country_id: 2, state_id: 33, city_id: 326, name: "Cary" },
    { country_id: 2, state_id: 33, city_id: 327, name: "Wilmington" },
    { country_id: 2, state_id: 33, city_id: 328, name: "High Point" },
    { country_id: 2, state_id: 33, city_id: 329, name: "Gastonia" },

    // North Dakota
    { country_id: 2, state_id: 34, city_id: 330, name: "Fargo" },
    { country_id: 2, state_id: 34, city_id: 331, name: "Bismarck" },
    { country_id: 2, state_id: 34, city_id: 332, name: "Grand Forks" },
    { country_id: 2, state_id: 34, city_id: 333, name: "Minot" },
    { country_id: 2, state_id: 34, city_id: 334, name: "West Fargo" },
    { country_id: 2, state_id: 34, city_id: 335, name: "Williston" },
    { country_id: 2, state_id: 34, city_id: 336, name: "Dickinson" },
    { country_id: 2, state_id: 34, city_id: 337, name: "Mandan" },
    { country_id: 2, state_id: 34, city_id: 338, name: "Jamestown" },
    { country_id: 2, state_id: 34, city_id: 339, name: "Wahpeton" },

    // Ohio
    { country_id: 2, state_id: 35, city_id: 340, name: "Columbus" },
    { country_id: 2, state_id: 35, city_id: 341, name: "Cleveland" },
    { country_id: 2, state_id: 35, city_id: 342, name: "Cincinnati" },
    { country_id: 2, state_id: 35, city_id: 343, name: "Toledo" },
    { country_id: 2, state_id: 35, city_id: 344, name: "Akron" },
    { country_id: 2, state_id: 35, city_id: 345, name: "Dayton" },
    { country_id: 2, state_id: 35, city_id: 346, name: "Parma" },
    { country_id: 2, state_id: 35, city_id: 347, name: "Canton" },
    { country_id: 2, state_id: 35, city_id: 348, name: "Youngstown" },
    { country_id: 2, state_id: 35, city_id: 349, name: "Lorain" },

    // Oklahoma
    { country_id: 2, state_id: 36, city_id: 350, name: "Oklahoma City" },
    { country_id: 2, state_id: 36, city_id: 351, name: "Tulsa" },
    { country_id: 2, state_id: 36, city_id: 352, name: "Norman" },
    { country_id: 2, state_id: 36, city_id: 353, name: "Broken Arrow" },
    { country_id: 2, state_id: 36, city_id: 354, name: "Lawton" },
    { country_id: 2, state_id: 36, city_id: 355, name: "Edmond" },
    { country_id: 2, state_id: 36, city_id: 356, name: "Moore" },
    { country_id: 2, state_id: 36, city_id: 357, name: "Midwest City" },
    { country_id: 2, state_id: 36, city_id: 358, name: "Enid" },
    { country_id: 2, state_id: 36, city_id: 359, name: "Stillwater" },

    // Oregon
    { country_id: 2, state_id: 37, city_id: 360, name: "Portland" },
    { country_id: 2, state_id: 37, city_id: 361, name: "Eugene" },
    { country_id: 2, state_id: 37, city_id: 362, name: "Salem" },
    { country_id: 2, state_id: 37, city_id: 363, name: "Gresham" },
    { country_id: 2, state_id: 37, city_id: 364, name: "Hillsboro" },
    { country_id: 2, state_id: 37, city_id: 365, name: "Beaverton" },
    { country_id: 2, state_id: 37, city_id: 366, name: "Bend" },
    { country_id: 2, state_id: 37, city_id: 367, name: "Medford" },
    { country_id: 2, state_id: 37, city_id: 368, name: "Springfield" },
    { country_id: 2, state_id: 37, city_id: 369, name: "Corvallis" },

    // Pennsylvania
    { country_id: 2, state_id: 38, city_id: 370, name: "Philadelphia" },
    { country_id: 2, state_id: 38, city_id: 371, name: "Pittsburgh" },
    { country_id: 2, state_id: 38, city_id: 372, name: "Allentown" },
    { country_id: 2, state_id: 38, city_id: 373, name: "Erie" },
    { country_id: 2, state_id: 38, city_id: 374, name: "Reading" },
    { country_id: 2, state_id: 38, city_id: 375, name: "Scranton" },
    { country_id: 2, state_id: 38, city_id: 376, name: "Bethlehem" },
    { country_id: 2, state_id: 38, city_id: 377, name: "Lancaster" },
    { country_id: 2, state_id: 38, city_id: 378, name: "Harrisburg" },
    { country_id: 2, state_id: 38, city_id: 379, name: "Altoona" },

    // Rhode Island
    { country_id: 2, state_id: 39, city_id: 380, name: "Providence" },
    { country_id: 2, state_id: 39, city_id: 381, name: "Warwick" },
    { country_id: 2, state_id: 39, city_id: 382, name: "Cranston" },
    { country_id: 2, state_id: 39, city_id: 383, name: "Pawtucket" },
    { country_id: 2, state_id: 39, city_id: 384, name: "East Providence" },
    { country_id: 2, state_id: 39, city_id: 385, name: "Woonsocket" },
    { country_id: 2, state_id: 39, city_id: 386, name: "Coventry" },
    { country_id: 2, state_id: 39, city_id: 387, name: "Cumberland" },
    { country_id: 2, state_id: 39, city_id: 388, name: "North Providence" },
    { country_id: 2, state_id: 39, city_id: 389, name: "South Kingstown" },

    // South Carolina
    { country_id: 2, state_id: 40, city_id: 390, name: "Charleston" },
    { country_id: 2, state_id: 40, city_id: 391, name: "Columbia" },
    { country_id: 2, state_id: 40, city_id: 392, name: "North Charleston" },
    { country_id: 2, state_id: 40, city_id: 393, name: "Mount Pleasant" },
    { country_id: 2, state_id: 40, city_id: 394, name: "Rock Hill" },
    { country_id: 2, state_id: 40, city_id: 395, name: "Greenville" },
    { country_id: 2, state_id: 40, city_id: 396, name: "Summerville" },
    { country_id: 2, state_id: 40, city_id: 397, name: "Goose Creek" },
    { country_id: 2, state_id: 40, city_id: 398, name: "Hilton Head Island" },
    { country_id: 2, state_id: 40, city_id: 399, name: "Spartanburg" },

    // South Dakota
    { country_id: 2, state_id: 41, city_id: 400, name: "Sioux Falls" },
    { country_id: 2, state_id: 41, city_id: 401, name: "Rapid City" },
    { country_id: 2, state_id: 41, city_id: 402, name: "Aberdeen" },
    { country_id: 2, state_id: 41, city_id: 403, name: "Brookings" },
    { country_id: 2, state_id: 41, city_id: 404, name: "Watertown" },
    { country_id: 2, state_id: 41, city_id: 405, name: "Mitchell" },
    { country_id: 2, state_id: 41, city_id: 406, name: "Yankton" },
    { country_id: 2, state_id: 41, city_id: 407, name: "Pierre" },
    { country_id: 2, state_id: 41, city_id: 408, name: "Huron" },
    { country_id: 2, state_id: 41, city_id: 409, name: "Vermillion" },

    // Tennessee
    { country_id: 2, state_id: 42, city_id: 410, name: "Nashville" },
    { country_id: 2, state_id: 42, city_id: 411, name: "Memphis" },
    { country_id: 2, state_id: 42, city_id: 412, name: "Knoxville" },
    { country_id: 2, state_id: 42, city_id: 413, name: "Chattanooga" },
    { country_id: 2, state_id: 42, city_id: 414, name: "Clarksville" },
    { country_id: 2, state_id: 42, city_id: 415, name: "Murfreesboro" },
    { country_id: 2, state_id: 42, city_id: 416, name: "Jackson" },
    { country_id: 2, state_id: 42, city_id: 417, name: "Johnson City" },
    { country_id: 2, state_id: 42, city_id: 418, name: "Franklin" },
    { country_id: 2, state_id: 42, city_id: 419, name: "Hendersonville" },

    // Texas
    { country_id: 2, state_id: 43, city_id: 420, name: "Houston" },
    { country_id: 2, state_id: 43, city_id: 421, name: "San Antonio" },
    { country_id: 2, state_id: 43, city_id: 422, name: "Dallas" },
    { country_id: 2, state_id: 43, city_id: 423, name: "Austin" },
    { country_id: 2, state_id: 43, city_id: 424, name: "Fort Worth" },
    { country_id: 2, state_id: 43, city_id: 425, name: "El Paso" },
    { country_id: 2, state_id: 43, city_id: 426, name: "Arlington" },
    { country_id: 2, state_id: 43, city_id: 427, name: "Corpus Christi" },
    { country_id: 2, state_id: 43, city_id: 428, name: "Plano" },
    { country_id: 2, state_id: 43, city_id: 429, name: "Laredo" },

    // Utah
    { country_id: 2, state_id: 44, city_id: 430, name: "Salt Lake City" },
    { country_id: 2, state_id: 44, city_id: 431, name: "West Valley City" },
    { country_id: 2, state_id: 44, city_id: 432, name: "Provo" },
    { country_id: 2, state_id: 44, city_id: 433, name: "West Jordan" },
    { country_id: 2, state_id: 44, city_id: 434, name: "Orem" },
    { country_id: 2, state_id: 44, city_id: 435, name: "Sandy" },
    { country_id: 2, state_id: 44, city_id: 436, name: "Ogden" },
    { country_id: 2, state_id: 44, city_id: 437, name: "St. George" },
    { country_id: 2, state_id: 44, city_id: 438, name: "Layton" },
    { country_id: 2, state_id: 44, city_id: 439, name: "Lehi" },

    // Vermont
    { country_id: 2, state_id: 45, city_id: 440, name: "Burlington" },
    { country_id: 2, state_id: 45, city_id: 441, name: "South Burlington" },
    { country_id: 2, state_id: 45, city_id: 442, name: "Rutland" },
    { country_id: 2, state_id: 45, city_id: 443, name: "Barre" },
    { country_id: 2, state_id: 45, city_id: 444, name: "Montpelier" },
    { country_id: 2, state_id: 45, city_id: 445, name: "St. Albans" },
    { country_id: 2, state_id: 45, city_id: 446, name: "Newport" },
    { country_id: 2, state_id: 45, city_id: 447, name: "Middlebury" },
    { country_id: 2, state_id: 45, city_id: 448, name: "Winooski" },
    { country_id: 2, state_id: 45, city_id: 449, name: "St. Johnsbury" },

    // Virginia
    { country_id: 2, state_id: 46, city_id: 450, name: "Virginia Beach" },
    { country_id: 2, state_id: 46, city_id: 451, name: "Norfolk" },
    { country_id: 2, state_id: 46, city_id: 452, name: "Chesapeake" },
    { country_id: 2, state_id: 46, city_id: 453, name: "Richmond" },
    { country_id: 2, state_id: 46, city_id: 454, name: "Newport News" },
    { country_id: 2, state_id: 46, city_id: 455, name: "Alexandria, Virginia" },
    { country_id: 2, state_id: 46, city_id: 456, name: "Hampton" },
    { country_id: 2, state_id: 46, city_id: 457, name: "Roanoke" },
    { country_id: 2, state_id: 46, city_id: 458, name: "Portsmouth" },
    { country_id: 2, state_id: 46, city_id: 459, name: "Suffolk" },

    // Washington
    { country_id: 2, state_id: 47, city_id: 460, name: "Seattle" },
    { country_id: 2, state_id: 47, city_id: 461, name: "Spokane" },
    { country_id: 2, state_id: 47, city_id: 462, name: "Tacoma" },
    { country_id: 2, state_id: 47, city_id: 463, name: "Vancouver" },
    { country_id: 2, state_id: 47, city_id: 464, name: "Bellevue" },
    { country_id: 2, state_id: 47, city_id: 465, name: "Kent" },
    { country_id: 2, state_id: 47, city_id: 466, name: "Everett" },
    { country_id: 2, state_id: 47, city_id: 467, name: "Renton" },
    { country_id: 2, state_id: 47, city_id: 468, name: "Spokane Valley" },
    { country_id: 2, state_id: 47, city_id: 469, name: "Federal Way" },

    // West Virginia
    { country_id: 2, state_id: 48, city_id: 470, name: "Charleston" },
    { country_id: 2, state_id: 48, city_id: 471, name: "Huntington" },
    { country_id: 2, state_id: 48, city_id: 472, name: "Morgantown" },
    { country_id: 2, state_id: 48, city_id: 473, name: "Parkersburg" },
    { country_id: 2, state_id: 48, city_id: 474, name: "Wheeling" },
    { country_id: 2, state_id: 48, city_id: 475, name: "Fairmont" },
    { country_id: 2, state_id: 48, city_id: 476, name: "Beckley" },
    { country_id: 2, state_id: 48, city_id: 477, name: "Martinsburg" },
    { country_id: 2, state_id: 48, city_id: 478, name: "Clarksburg" },
    { country_id: 2, state_id: 48, city_id: 479, name: "Weirton" },

    // Wisconsin
    { country_id: 2, state_id: 49, city_id: 480, name: "Milwaukee" },
    { country_id: 2, state_id: 49, city_id: 481, name: "Madison" },
    { country_id: 2, state_id: 49, city_id: 482, name: "Green Bay" },
    { country_id: 2, state_id: 49, city_id: 483, name: "Kenosha" },
    { country_id: 2, state_id: 49, city_id: 484, name: "Racine" },
    { country_id: 2, state_id: 49, city_id: 485, name: "Appleton" },
    { country_id: 2, state_id: 49, city_id: 486, name: "Waukesha" },
    { country_id: 2, state_id: 49, city_id: 487, name: "Oshkosh" },
    { country_id: 2, state_id: 49, city_id: 488, name: "Eau Claire" },
    { country_id: 2, state_id: 49, city_id: 489, name: "Janesville" },

    // Wyoming
    { country_id: 2, state_id: 50, city_id: 490, name: "Cheyenne" },
    { country_id: 2, state_id: 50, city_id: 491, name: "Casper" },
    { country_id: 2, state_id: 50, city_id: 492, name: "Laramie" },
    { country_id: 2, state_id: 50, city_id: 493, name: "Gillette" },
    { country_id: 2, state_id: 50, city_id: 494, name: "Rock Springs" },
    { country_id: 2, state_id: 50, city_id: 495, name: "Sheridan" },
    { country_id: 2, state_id: 50, city_id: 496, name: "Green River" },
    { country_id: 2, state_id: 50, city_id: 497, name: "Evanston" },
    { country_id: 2, state_id: 50, city_id: 498, name: "Riverton" },
    { country_id: 2, state_id: 50, city_id: 499, name: "Jackson" },
  ].sort((a, b) => a.name.localeCompare(b.name)),
};
